var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.2 23.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#0f4c86;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,9.6H15v-1.4H3.9v1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,15.9v1.4h5.9c0-.5,.1-.9,.3-1.4H3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,4.4v1.4h6.9v-1.4H3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,13.4h7.9c.9-.8,2-1.3,3.3-1.4H4c-.1,.5-.1,1-.1,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.4,20.2H3.2c-.9,0-1.2-.3-1.2-1.2V2.7c0-.9,.3-1.2,1.2-1.2H12.7V3.5c-.1,1.4,1.1,2.3,2.2,2.3h1.9v6.4c.5,.1,1,.3,1.4,.6V6.3c0-.7-.2-1.3-.7-1.8-1.3-1.4-2.6-3-4-4.5H3.1C1.6,0,.7,1,.7,2.6V19c0,1.7,.9,2.7,2.6,2.7H11.4c-.4-.5-.7-1-1-1.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.5,13.4c-2.4,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3,4.3-1.9,4.3-4.3-2-4.3-4.3-4.3Zm2.1,5l-1.8,1.8c-.1,.1-.2,.1-.3,.1s-.2,0-.3-.1l-1.8-1.8c-.2-.2-.2-.4,0-.6l.2-.2c.2-.2,.4-.2,.6,0l.7,.7v-2.8c0-.2,.2-.4,.4-.4h.3c.2,0,.4,.2,.4,.4v2.8l.7-.7c.2-.2,.4-.2,.6,0l.2,.2c.2,.1,.2,.4,.1,.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.39a0cd058c1b754ff51e524758c84398.svg";
export { ForwardRef as ReactComponent };